/**
 * Adres macierzysty — zakładka „Dane" (kontrahent) — WF NEW 2026-08-14 (Opcja B),
 * ujednolicony z modalem „Nowy adres" (zakładka Adresy) na wspólny komponent
 * `AddressCoreFields` — WF NEW 2026-08-20.
 *
 * Adres macierzysty (siedziba/rejestrowy = jeden wiersz tabeli `addresses`, `kind=office`
 * `isPrimary`) renderuje się jako JEDNA sekcja z 7 polami core adresu (ten sam komponent
 * i te same etykiety co w modalu adresów). Bufor formularza: `form.primaryAddress`,
 * zapis razem z kontrahentem (saveAggregate).
 */

import {
  ADDRESS_CORE_FIELD_I18N_SUFFIX,
  ADDRESS_CORE_FIELD_ORDER,
  type AddressCoreField,
  AddressCoreFields,
  parseHiddenAddressCoreFields,
  POLAND_COUNTRY_CODE,
} from '@/components/addresses/AddressCoreFields';
import type { ContractorPrimaryAddress } from '@/components/contractors/ContractorDataTab';
import { Section } from '@/components/kartoteki/CoreFieldLayout';

export { POLAND_COUNTRY_CODE };

/** Re-export dla Kreatora (builder-preview `ContractorPrimaryAddressViewElement`). */
export const PRIMARY_ADDRESS_FIELD_ORDER = ADDRESS_CORE_FIELD_ORDER;
export const PRIMARY_ADDRESS_FIELD_I18N_SUFFIX = ADDRESS_CORE_FIELD_I18N_SUFFIX;
export const parseHiddenPrimaryAddressFields = parseHiddenAddressCoreFields;

export interface ContractorPrimaryAddressSectionProps {
  value: ContractorPrimaryAddress;
  onChange: (next: ContractorPrimaryAddress) => void;
  editable: boolean;
  /** Klucze pól ukrytych przez konfigurację elementu w kreatorze (Model B v1). */
  hiddenFields?: ReadonlyArray<AddressCoreField>;
  /** Kolejność pól (slugi) z formatki — drag w builderze; nieujęte na końcu. */
  fieldOrder?: ReadonlyArray<string>;
  /** Tytuł sekcji (domyślnie „Adres macierzysty"). */
  title?: string;
}

/**
 * Adres macierzysty jako JEDNA formatka (Model B v1) — wszystkie pola w jednej sekcji,
 * stała kolejność, z ukrywaniem pól (`hiddenFields`). To ten sam bufor
 * `form.primaryAddress` co dotychczas — zapis bez zmian.
 */
export function ContractorPrimaryAddressSection({
  value,
  onChange,
  editable,
  hiddenFields = [],
  fieldOrder,
  title = 'Adres macierzysty',
}: ContractorPrimaryAddressSectionProps) {
  return (
    <Section title={title}>
      <AddressCoreFields
        value={value}
        onChange={onChange}
        editable={editable}
        hiddenFields={hiddenFields}
        fieldOrder={fieldOrder}
      />
    </Section>
  );
}
